import { render, staticRenderFns } from "./OfferAffSubBlacklist.vue?vue&type=template&id=88f77b80&"
import script from "./OfferAffSubBlacklist.vue?vue&type=script&lang=js&"
export * from "./OfferAffSubBlacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports